export default "__VITE_ASSET__CpLbvVYk__"